<div class="p-4" *transloco="let t; read 'admin-pages.dashboard.table';">

  <!--  t(admin-pages.dashboard.table.lat, admin-pages.dashboard.table.lng, admin-pages.dashboard.table.annual-co2-reduction, admin-pages.dashboard.table.investment, admin-pages.dashboard.table.investment-return, admin-pages.dashboard.table.system-capacity, admin-pages.dashboard.table.source, admin-pages.dashboard.table.time, admin-pages.dashboard.table.omm, admin-pages.dashboard.table.tariff-group)  -->
  <ngx-datatable
    [messages]="{emptyMessage: 'no_data_in_table' | transloco}"
    class="material"
    [loadingIndicator]="loading"
    [rows]="statTableData"
    [columnMode]="ColumnMode.force"
    [sortType]="SortType.single"
    [limit]="12"
    [footerHeight]="50"
    [rowHeight]="50"
    [headerHeight]="50"
    (activate)="onRowSelect($event)">
    <ngx-datatable-column
      *ngFor="let column of basicColumns"
      [name]="t(column.translationKey)"
      [prop]="column.prop"
      [comparator]="column.prop === 'time' ? dateComparator : null">
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{
          column.prop === 'time'
            ? (value ? (value | date:'dd.MM.yyyy. HH:mm') : '-')
            : column.text
              ? (value || '-')
              : (value ? (value | number:'0.0-2') : '-')
        }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      [name]="t('user-contact')"
      [pipe]="fillIfEmptyValuePipe"
      prop="userContact">
    </ngx-datatable-column>

  </ngx-datatable>

</div>
